import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';
import { AppointmentSchedulingConfiguration } from '../../config/appointment_scheduling_configuration';
import { AppointmentButtonServant } from '../../servants/appointment_button_servant';
import { AppointmentsChoiceSelectorServant } from '../../servants/appointments_choice_selector_servant';

export class ChoiceSelectorController {
  private _choiceActive: boolean = false;
  private choices: any[];
  private choiceSelected: (arg: any) => void;
  private instructions: string;
  private multi: boolean = false;
  private value: string[] | string;
  private backText: string;
  private renderFunction: (arg: any) => string;
  private nextText: string;
  private optional: boolean;
  private isMobile: boolean;

  constructor(
    private ngAppointmentSchedulingConfiguration: AppointmentSchedulingConfiguration,
    private ngAppointmentsChoiceSelectorServant: AppointmentsChoiceSelectorServant,
    private ngAppointmentButtonServant: AppointmentButtonServant
  ) {
    this.toggleChoice = this.toggleChoice.bind(this);
    this.next = this.next.bind(this);
  }

  get choiceActive(): boolean {
    return this._choiceActive;
  }

  $onInit() {
    this.ngAppointmentsChoiceSelectorServant.add(this);
    this.nextText = !!this.nextText ? this.nextText : 'Answer Next Question';
    this.optional = !!this.optional;
    this.isMobile = PlatformUtility.isMobile();
  }

  $onDestroy() {
    this.ngAppointmentsChoiceSelectorServant.remove(this);
  }

  isItemSelected(itemName: string): boolean {
    if (_4.isString(this.value)) {
      return this.value === itemName;
    }
    return this.value.includes(itemName);
  }

  toggleChoice() {
    this._choiceActive = !this._choiceActive;
    this.configureButton();
  }

  toggleChoiceForMobile() {
    if (this.isMobile) {
      this.toggleChoice();
    }
  }

  $onChanges(changesObject: any) {
    if (this.choiceActive && this.isComplete === this.ngAppointmentButtonServant.isDisabled) {
      this.ngAppointmentButtonServant.isDisabled = !this.isComplete;
    }
  }

  onChosen(choice: any) {
    this.choiceSelected(choice);
  }

  next() {
    this.ngAppointmentsChoiceSelectorServant.next(this);
  }

  get isComplete(): boolean {
    return this.value.length > 0 || this.optional;
  }

  configureButton() {
    if (this.choiceActive) {
      this.ngAppointmentButtonServant.configButton({
        isDisabled: !this.isComplete,
        action: this.next,
        buttonText: this.nextText
      });
    } else {
      this.ngAppointmentButtonServant.setDefaults();
      // TODO: Configure next button
      // this.ngAppointmentButtonServant.buttonText = 'Continue to Location & Staff';
    }
  }

  render(item: any): string {
    if (!!this.renderFunction) {
      return this.renderFunction(item);
    }
    return item.name;
  }
}

export class ChoiceSelectorComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-appointments/src/components/choice_selector/choice_selector.html';
  public controllerAs: string = '$ctrl';
  public controller: any = ChoiceSelectorController;
  public bindings: any = {
    choices: '<',
    choiceSelected: '<',
    instructions: '<',
    multi: '<',
    value: '<',
    backText: '<',
    renderFunction: '<',
    optional: '<',
    nextText: '<'
  };
}

angular
  .module('capability-ng-appointments')
  .controller('ChoiceSelectorController', ChoiceSelectorController)
  .component('choiceSelector', new ChoiceSelectorComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/components/choice_selector/choice_selector.ts